export default {
    modal: {
        position: "fixed", /* Stay in place */
        zIndex: "999999999999 !important", /* Sit on top */
        left: 0,
        top: 0,
        width: "100%", /* Full width */
        height: "100%", /* Full height */
        overflow: "auto", /* Enable scroll if needed */
        backgroundColor: "rgba(0,0,0,0.2)" /* Black w/ opacity */,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
    },
    /* Modal Content */
    modalCont: {
        backgroundColor: "#fefefe",
        padding: "32px 42px",
        border: "1px solid rgba(0,0,0,0.19)",
        width: '34.75%',
        maxWidth: '600px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-evenly',
        boxSizing: 'border-box',
        minHeight: 277,
        borderRadius: 4,
        '&.thin': {
            padding: '10px 42px 42px 42px'
        },
        '&.thinner': {
            padding: '12px',
            width: 'auto'
        }
    },
    modalAction: {
        display: "flex",
        margin: "12px 0",
        justifyContent: "space-around",
        '& button': {
            minWidth: "195px",
        }
    },
    modalContent: {
        textAlign: 'center',
        lineHeight: 1.5
    },
    warningInfo: {
        marginTop: 6,
        padding: '6px 12px',
        backgroundColor: '#ffebde',
        lineHeight: 1.5
    },
    footer: {
        width: '34.75%',
        boxSizing: 'border-box',
        border: 'solid 1px rgba(0,0,0,0.19)',
        padding: '5px 22px',
        backgroundColor: '#f8f8f8',
        borderTop: 'none',
        lineHeight: '20px'
    }
};
